<template>
  <v-app>
    <Overlay :overlay="overlay" />
    <Snackbar :SnackBarComponent="SnackBarComponent" />
    <ProfileDetailsPendingDialog
      :getCurrentUserDetailsObject="getCurrentUserDetailsObject"
      :dialogProfileDetailsPending="dialogProfileDetailsPending"
      @clicked="dialogProfileDetailsPendingEmit"
    />
    <KYCPendingDialog
      :dialogKYCPending="dialogKYCPending"
      @clicked="dialogKYCPendingEmit"
    />
    <LogOutWarningDialog
      v-if="dialogLogoutWarning"
      :dialogLogoutWarning="dialogLogoutWarning"
      @clicked="dialogLogoutWarning = false"
    />
    <CarDetailsDialog
      :CardetailsDialog="CardetailsDialog"
      @clicked="CarDialogEmit"
      :StoreObj="StoreObj"
    />
    <AddFavouriteViolationDialog
      :FavouriteViolation="FavouriteViolation"
      :StoreObj="StoreObj"
      @clicked="dialogFavouriteViolationEmit"
    />
    <PoliceHistory
      :PoliceHistory="PoliceHistory"
      @clicked="HistoryDialogEmit"
    />
    <v-app-bar
      v-if="$route.path !== '/VideoCall' && $route.path !== '/Chat'"
      app
      clipped-left
      color="white"
      elevation="1"
    >
      <v-card class="elevation-0 mr-2">
        <v-img src="@/assets/MIHS_logo/MIHS_logo.png" width="40"></v-img>
      </v-card>

      <div v-for="(btn, index) in RouterList" :key="index">
        <v-btn
          :text="btn.MenuRoute == MenuRoute ? false : true"
          color="primary"
          x-small
          class="text-capitalize"
          @click="routeNavigateMethod(btn)"
        >
          {{ btn.MenuName }}
        </v-btn>
      </div>
      <v-btn
        v-if="$vuetify.breakpoint.name == 'xs'"
        x-small
        dark
        icon
        class="text-capitalize ma-3"
        @click="fetchlocation()"
        ><v-icon x-small color="primary">mdi-map-marker</v-icon></v-btn
      >
      <v-btn
        v-if="$vuetify.breakpoint.name != 'xs'"
        x-small
        class="text-capitalize ma-3"
        dark
        @click.stop="fetchlocation()"
        color="orange"
        ><v-icon x-small color="white" class="mr-2">mdi-map-marker</v-icon
        >Update Location</v-btn
      >
      <v-spacer />
      <!-- <v-tooltip bottom color="black">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            v-on="on"
            v-bind="attrs"
            depressed
            class="mr-6 mt-3"
            x-small
            dark
            @click="AddFavouriteViolationMethod()"
            ><v-icon small class="mr-2">mdi-alert</v-icon>Violation</v-btn
          >
        </template>
        <span>Favourite Violations</span>
      </v-tooltip> -->

      <v-tooltip bottom color="black">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-on="on"
            v-bind="attrs"
            depressed
            fab
            small
            class="mr-4"
            color="primary"
            @click="drawer = !drawer"
            ><v-icon>mdi-view-list</v-icon></v-btn
          >
        </template>
        <span>Settings</span>
      </v-tooltip>
      <v-card
        color="#f6f6f6"
        class="elevation-0"
        v-if="$vuetify.breakpoint.name != 'xs'"
      >
        <div class="text-center mr-2">
          <div
            class="font-weight-bold FontSize mr-3"
            v-if="getCurrentUserDetailsObject.user_name"
            align="center"
          >
            <v-icon v-if="PoliceImage == ''" color="primary"
              >mdi-account-circle</v-icon
            >
            <v-avatar
              v-else
              :size="$vuetify.breakpoint.name != 'sm' ? 30 : 20"
              rounded=""
              class="mr-2 mt-1"
            >
              <v-img :src="PoliceImage"></v-img>
            </v-avatar>
            <span class="mb-n2 FontSize">{{
              getCurrentUserDetailsObject.user_name
            }}</span>
          </div>
          <div class="fontSizeSmall ml-4" align="center">
            {{ $store.getters.get_user_email }}
          </div>
        </div>
      </v-card>

      <v-tooltip bottom color="black">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="LogoutMethod()" v-on="on" v-bind="attrs">
            <v-icon color="primary" large dark>mdi-exit-to-app</v-icon>
          </v-btn></template
        >
        <span>LOGOUT</span>
      </v-tooltip>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      bottom
      app
      temporary
      right
      width="320px"
      height="100%"
      color="primary"
    >
      <v-list-item class="pa-2 ml-2" color="white">
        <!-- <v-list-item-avatar> -->
        <v-icon color="white">mdi-cog</v-icon>
        <!-- </v-list-item-avatar> -->

        <v-list-item-content>
          <v-list-item-title class="white--text ml-3 font-weight-bold"
            >Settings</v-list-item-title
          >
        </v-list-item-content>
        <v-spacer />
        <v-btn dark small icon @click.stop="drawer = false"
          ><v-icon>mdi-close-circle</v-icon></v-btn
        >
      </v-list-item>
      <v-divider class="white-divider"></v-divider>

      <v-list dense>
        <v-list-item
          @click="AddFavouriteViolationMethod()"
          class="hover-list-item my-3"
        >
          <v-icon color="white">mdi-star-circle</v-icon>

          <v-list-item-content>
            <v-list-item-title class="white--text ml-3"
              >Favourite Violations</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>

        <!-- <v-list-item
          @click.stop="SwitchBooleanMethod()"
          class="hover-list-item my-3"
        >
          <v-icon color="white">mdi-bell</v-icon>

          <v-list-item-content>
            <v-list-item-title class="white--text ml-3"
              >Notification Type<v-icon color="white" class="ml-2" small>{{
                SwitchBoolean == false ? "mdi-chevron-down" : "mdi-chevron-up"
              }}</v-icon></v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="SwitchBoolean == true" class="ml-8" dense>
          <v-card height="40px">
            <v-row>
              <v-col cols="5" md="5" xs="5" sm="5" class="mt-2">
                <div class="ml-2">Audio</div>
              </v-col>
              <v-col cols="3" md="3" xs="3" sm="3" class="mt-n3">
                <v-switch v-model="AudioSwitch" class="ml-n3"></v-switch>
              </v-col>
              <v-col cols="4" md="4" xs="4" sm="4" class="mt-2">
                <div>Tone</div></v-col
              >
            </v-row>
          </v-card>
        </v-list-item> -->
        <v-list-item
          @click="$router.push('/MyProfile')"
          class="hover-list-item my-3"
        >
          <v-icon color="white">mdi-account</v-icon>

          <v-list-item-content>
            <v-list-item-title class="white--text ml-3"
              >My Profile</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click.stop="Get_User_Activities_Method()"
          class="hover-list-item my-3"
        >
          <v-icon color="white">mdi-history</v-icon>

          <v-list-item-content>
            <v-list-item-title class="white--text ml-3"
              >My Activities</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn class="btn-item" block @click="LogoutMethod()"> Logout </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>
<script>
import Overlay from "@/components/Extras/Overlay.vue";
import Snackbar from "@/components/Extras/Snackbar.vue";
import LogOutWarningDialog from "@/components/Extras/LogOutWarningDialog.vue";
import ProfileDetailsPendingDialog from "@/components/Extras/ProfileDetailsPendingDialog.vue";
import AddFavouriteViolationDialog from "@/components/Violations/Dialogs/AddFavouriteViolation.vue";
import CarDetailsDialog from "@/components/Extras/CarDetailsDialog.vue";
import KYCPendingDialog from "@/components/Extras/KYCPendingDialog.vue";
import { GetCurrentUserDetails } from "@/mixins/GetCurrentUserDetails.js";
import { GetAllNearMotorist } from "@/mixins/Methods/PoliceNearDetails.js";
import { GenerateS3URL } from "@/mixins/ImageUpload.js";
import PoliceHistory from "@/components/Extras/ListHistoryDialog.vue";
import { RecordDetailsOfPolice } from "@/mixins/Methods/RecordDetails.js";

import RouterList from "@/JsonFiles/RouterList.json";
import axios from "axios";

export default {
  mixins: [
    GetCurrentUserDetails,
    GetAllNearMotorist,
    GenerateS3URL,
    RecordDetailsOfPolice,
  ],
  components: {
    Overlay,
    Snackbar,
    LogOutWarningDialog,
    ProfileDetailsPendingDialog,
    KYCPendingDialog,
    CarDetailsDialog,
    AddFavouriteViolationDialog,
    PoliceHistory,
  },
  data: () => ({
    Height: 0,
    AudioSwitch: false,
    SwitchBoolean: false,
    selectedItem: 0,
    drawer: null,
    PoliceHistory: false,
    Navitems: [
      {
        title: "Favourite Violations",
        icon: "mdi-alert",
        color: "primary",
        ClickMethod: "this.AddFavouriteViolationMethod",
      },
      { title: "About", icon: "mdi-forum", color: "green" },
    ],

    Search: "",
    MenuRoute: "",
    PoliceImage: "",
    StoreObj: {},
    SnackBarComponent: {},
    isEdge: false,
    menu: false,
    overlay: false,
    height: 0,
    FavouriteViolation: false,
    CardetailsDialog: false,
    dialogKYCPending: false,
    dialogLogoutWarning: false,
    dialogProfileDetailsPending: false,
    currentLocation: {
      lat: "",
      lng: "",
    },

    CreateAd: {
      Latitude: "",
      Longitude: "",
    },
    center: {
      lat: null,
      lng: null,
    },
    currentPlace: {},
    mapOptions: {
      restriction: {
        latLngBounds: {
          north: 49.384358,
          south: 24.396308,
          west: -125.0,
          east: -66.93457,
        },
        strictBounds: true,
      },
    },
    locationMarkers: [],
    RouterList: [],
    locationInterval: null,
  }),
  watch: {
    drawer(val) {
      if (val == false) {
        this.SwitchBoolean = false;
      }
    },
  },
  async mounted() {
    this.RouterList = RouterList;
    this.height = window.innerHeight - 0;
    if (this.$store.getters.get_auth != true) {
      this.$router.push("/");
    } else {
      this.verifyUserCurrentStatusConditionMethod();
      // if (this.$store.getters.get_current_location == true) {
      //   this.SetMyLocation();
      //   this.locationInterval = setInterval(() => {
      //     this.SetMyLocation();
      //   }, 90000);
      // }
      // this.locateGeoLocation();
      // this.verifyUserCurrentStatusConditionMethod();
    }
  },

  beforeDestroy() {
    console.log("Destroyed");
    this.clearLocationInterval();
  },
  methods: {
    // SwitchBooleanMethod() {
    //   if (this.SwitchBoolean === false) {
    //     this.SwitchBoolean = true;
    //   } else {
    //     this.SwitchBoolean = false;
    //   }
    // },
    clearLocationInterval() {
      if (this.locationInterval) {
        clearInterval(this.locationInterval);
        this.locationInterval = null;
      }
    },

    routeNavigateMethod(btn) {
      this.MenuRoute = btn.MenuRoute;
      this.$router.push(btn.MenuRoute);
    },
    dialogKYCPendingEmit(Toggle) {
      this.dialogKYCPending = false;
      if (Toggle == 2) {
        this.verifyUserCurrentStatusConditionMethod();
      }
    },
    dialogProfileDetailsPendingEmit(Toggle) {
      this.dialogProfileDetailsPending = false;
      if (Toggle == 2) {
        this.verifyUserCurrentStatusConditionMethod();
      }
    },
    async verifyUserCurrentStatusConditionMethod() {
      await this.GetCurrentUser();
      let CurrentUserDetailsObj = this.$store.getters.get_current_user_details;
      if (CurrentUserDetailsObj.user_image_url != undefined) {
        if (
          CurrentUserDetailsObj.user_image_url != undefined ||
          CurrentUserDetailsObj.user_image_url != null ||
          CurrentUserDetailsObj.user_image_url != ""
        ) {
          if (
            !CurrentUserDetailsObj.user_image_url.includes(
              "https://makeithomesafe.s3.us-east-1.amazonaws.com"
            )
          ) {
            const url = CurrentUserDetailsObj.user_image_url;
            const parts = url.split("/");
            const path = parts
              .slice(parts.indexOf("police_profiles"))
              .join("/");
            // console.log("pathg", path);
            this.PoliceImage = await this.GenerateS3URLMethods(`${path}`);
          } else {
            const filename = CurrentUserDetailsObj.user_image_url
              .split("?")[0]
              .split("/")
              .pop();
            const decodedFileName = decodeURIComponent(filename);
            this.PoliceImage = await this.GenerateS3URLMethods(decodedFileName);
          }
        }
      }

      // this.fetchlocation();
      switch (CurrentUserDetailsObj.user_status) {
        case "INCOMPLETE_PROFILE":
          this.dialogProfileDetailsPending = true;
          break;
        case "PENDING":
          this.dialogKYCPending = true;
          break;
        case "ACTIVE":
          if (
            // CurrentUserDetailsObj.precinct_phone_number != undefined ||
            CurrentUserDetailsObj.zip_code != undefined
          ) {
            this.MenuRoute = this.RouterList[0].MenuRoute;
            if (this.$store.getters.get_current_location == true) {
              this.SetMyLocation();
              this.locationInterval = setInterval(() => {
                this.SetMyLocation();
              }, 90000);
            }
          } else {
            this.dialogProfileDetailsPending = true;
          }
          break;
        default:
          // this.$router.push(this.RouterList[0].MenuRoute);
          this.MenuRoute = this.RouterList[0].MenuRoute;
          if (this.$store.getters.get_current_location == true) {
            this.SetMyLocation();
            this.locationInterval = setInterval(() => {
              this.SetMyLocation();
            }, 90000);
          }
          break;
      }
    },
    async fetchlocation() {
      if (
        this.$store.getters.get_current_user_details.user_status == "ACTIVE"
      ) {
        if ("geolocation" in navigator) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              this.overlay = true;
              this.currentLocation.lat = position.coords.latitude;
              this.currentLocation.lng = position.coords.longitude;
              this.GetAllNearMotoristMethod(
                this.currentLocation.lat,
                this.currentLocation.lng,
                "fetchlocation"
              );
              // this.convertCoordinatesToAddress();
            },
            (error) => {
              if (error.code === error.PERMISSION_DENIED) {
                this.SnackBarComponent = {
                  SnackbarVmodel: true,
                  SnackbarColor: "grey",
                  Top: true,
                  SnackbarText:
                    "Enable location through Browser settings to get further Notifications",
                };
              }
            }
          );
        }
      }
    },
    async LogoutMethod() {
      if (this.$store.getters.get_complete_data != {}) {
        await this.SetEndLocation();
      }
      this.$router.push("/");
      this.$store.commit("SET_MOTORIST_BOOLEAN", false);
      this.$store.commit("SET_CURRENTUSER_DETAILS", {});
      this.$store.commit("SET_AUTH", false);
      this.$store.commit("SET_MOTORIST_AGAIN", true);
      this.$store.commit("SET_MOTORIST_NAME", {});
      this.$store.commit("SET_CHAT_LIST", {});
      this.$store.commit("SET_SUBSCRIPTION_STATUS", false);
      this.$store.commit("SET_CURRENT_LOCATION", false);
      this.$store.commit("SET_COMPLETE_DATA", {});

      setTimeout(() => {
        console.log("StoredArray", this.$store.getters.get_complete_data);
      }, 2000);
    },
    CarDialogEmit() {
      this.CardetailsDialog = false;
    },
    // SetLocationMethod() {
    //   this.GetAllNearMotoristMethod(
    //     this.currentPlace.Latitude,
    //     this.currentPlace.Longitude
    //   );
    //   this.menu = false;
    //   this.SnackBarComponent = {
    //     SnackbarVmodel: true,
    //     SnackbarColor: "green",
    //     Top: true,
    //     SnackbarText: "Location Updated",
    //   };
    // },
    AddFavouriteViolationMethod() {
      this.FavouriteViolation = true;
      this.drawer = false;
    },
    dialogFavouriteViolationEmit(Toggle) {
      this.FavouriteViolation = false;
      if (Toggle == 2) {
        this.GetCurrentUser();
      }
    },
    durationMethod(item) {
      const diffMs = item - this.$store.getters.get_complete_data.StartDate;

      const minutes = Math.floor(diffMs / (1000 * 60));
      const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

      const formattedDuration = minutes + seconds / 100;

      return formattedDuration;
    },
    async SetEndLocation() {
      try {
        const payload = {
          considerIp: "true",
        };

        const response = await axios.post(
          `https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyBrftCAqKGbs4qrzM1JL8_Sb8Kl7Dk5CLQ`,
          payload
        );
        const { lat, lng } = response.data.location;

        let EndLocation = [
          lat,
          lng,
          await this.convertCoordinatesToAddress(lat, lng),
        ];
        let EndTime = new Date().getTime();
        let TotalDuration = await this.durationMethod(EndTime);
        let monthName = new Date().getMonth() + 1;
        const months = [
          "january",
          "february",
          "march",
          "april",
          "may",
          "june",
          "july",
          "august",
          "september",
          "october",
          "november",
          "december",
        ];

        let FullMonth = months[monthName - 1];
        let FullYear = new Date().getFullYear();

        this.$store.commit("SET_COMPLETE_DATA", {
          EndTime,
          EndLocation,
          TotalDuration,
          FullMonth,
          FullYear,
        });
        await this.RecordDetailsOfPoliceMethod();
      } catch (error) {
        console.log(error);
      }
    },
    async SetMyLocation() {
      try {
        const response = await axios.post(
          `https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyBrftCAqKGbs4qrzM1JL8_Sb8Kl7Dk5CLQ`
        );
        const { lat, lng } = response.data.location;
        this.latitude = lat;
        this.longitude = lng;
        this.GetAllNearMotoristMethod(
          this.latitude,
          this.longitude,
          "NearByLocation"
        );
      } catch (error) {
        console.log(error);
      }
    },
    Get_User_Activities_Method() {
      this.PoliceHistory = true;
    },
    HistoryDialogEmit() {
      this.PoliceHistory = false;
    },
  },
};
</script>

<style scoped>
.autocomplete-input {
  height: 30px;
  font-size: 14px;
  background-color: #c0c0c0;
}
.bottom-logout {
  margin-top: auto;
  padding: 16px;
}
</style>
